import React from 'react';
import OurServices from '../components/OurServices/OurServices';
import './InnerPage.css';

export default function ServicesPage() {
  return (
    <div className="inner-page">
      <div className="inner-hero" style={{ background: 'linear-gradient(135deg,#0A0A0A,#1a1a2e)' }}>
        <div className="inner-hero-content">
          <span className="inner-eyebrow">What We Offer</span>
          <h1>Our <span className="gold">Services</span></h1>
          <p>Tailored real estate solutions — from buying & selling to investment advisory</p>
        </div>
      </div>
      <OurServices />
    </div>
  );
}
